import styled from 'styled-components';

export const Box = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  gap: 10px;
  height: 64px;

  background: ${(props) => props.theme.colors['neutral-10']};
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.07);
  border: 1px solid ${(props) => props.theme.colors['neutral-30']};
  border-radius: 4px;
  transition: all 0.2s ease-in-out;

  &:hover {
    cursor: pointer;
    box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.27);
    transition: all 0.2s ease-in-out;
  }

  &:not(&:last-of-type) {
    margin-bottom: 16px;
  }
`;

export const Icon = styled.div`
  background: ${(props) => props.theme.colors['secondary-20']};
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    color: ${(props) => props.theme.colors['primary-60']};
  }
`;

export const Title = styled.p`
  font-size: 14px;
  line-height: 150%;
  color: ${(props) => props.theme.colors['neutral-100']};
`;
